// extracted by mini-css-extract-plugin
module.exports = {"accountSidebarTitle":"AccountSidebarTitle_accountSidebarTitle___EJA8"};